$(document).ready(function () {

  $('.navbar-header > button.navbar-toggle').on('click', function (event) {
    if ($(this).hasClass('collapsed')) {
      $('body').addClass('locked-scroll');
    } else {
      $('body').removeClass('locked-scroll');
    }
  })

  $(window).on('resize', resizeMenu).toggle('resize');
});

function resizeMenu() {
  var count = $('#evenly-spaced-menu').children('li').length;
  $('.main-menu-wrapper ul.dropdown-menu').slideDown(0);
  $('.main-menu-wrapper .dropdown .dropdown-toggle').off();

  if ($(window).innerWidth() > 1200) {
    $('#evenly-spaced-menu').children('li').css('width', 100 / count + '%');
    $('#evenly-spaced-menu').children('li').css('clear', 'initial');
  } else if ($(window).innerWidth() < 768) {
    $('.main-menu-wrapper ul.dropdown-menu').slideUp(0);
    $('#evenly-spaced-menu').children('li').css('width', '100%');
    $('#evenly-spaced-menu').children('li').css('clear', 'initial');
    $('.main-menu-wrapper .dropdown .dropdown-toggle').off().click(function () {
      if ($(this).parent().children('ul.dropdown-menu').css('display') === 'none') {
        $('.main-menu-wrapper ul.dropdown-menu').slideUp("fast");
        $(this).parent().children('ul.dropdown-menu').slideDown("fast");
      } else {
        $(this).parent().children('ul.dropdown-menu').slideUp("fast");
      }
    });
  } else {
    count2 = Math.ceil(count / 2);
    $('#evenly-spaced-menu').children('li').slice(0, count2).css('width', 100 / count2 + '%');
    $('#evenly-spaced-menu').children('li').slice(count2, count).css('width', 100 / (count2 - 1) + '%');
    $('#evenly-spaced-menu').children('li').eq(count2).css('clear', 'both');
  }
}
